import clsx from 'clsx'
import React, { HTMLAttributes } from 'react'

import Styles from './ContentBlock.module.scss'

interface Props extends HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode
  className?: string
  mode?: 'dark' | 'light'
}

const ContentBlock = React.memo(
  ({ className, children, mode = 'light', ...props }: Props) => {
    return (
      <div className={clsx(Styles.wrapper, Styles[mode], className)} {...props}>
        {children}
      </div>
    )
  }
)

ContentBlock.displayName = 'ContentBlock'
export default ContentBlock
